import { render, staticRenderFns } from "./ModalGroups.vue?vue&type=template&id=6ba0b2a3&scoped=true&"
import script from "./ModalGroups.vue?vue&type=script&lang=js&"
export * from "./ModalGroups.vue?vue&type=script&lang=js&"
import style0 from "./ModalGroups.vue?vue&type=style&index=0&id=6ba0b2a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba0b2a3",
  null
  
)

export default component.exports